import { Pipe, PipeTransform } from '@angular/core';
import { RfqQuote } from '@approot/models';

@Pipe({
  name: 'quoteFilterByProvider'
})
export class QuoteFilterByProviderPipe implements PipeTransform {
  transform(
    quotes: RfqQuote[],
    filterBy: string,
    includedIn: boolean
  ): RfqQuote[] {
    if (includedIn == null || !filterBy) {
      return quotes;
    }
    return quotes.filter(x =>
      includedIn ? x.bank === filterBy : x.bank !== filterBy
    );
  }
}
